<div class="w100 col gap-16">
    <rr-icon name="wind" class="roundicon" tone="nutral"></rr-icon>
    <div class="col w100 gap-8">
        <h3 i18n>Select your Stream</h3>
        <div class="row gap-4 align-center">
            <span>Credits:</span>
            <span class="strong color-brand">{{
                data.userCredits === -1 ? "Unlimited" : data.userCredits
            }}</span>
            <!-- <span>|</span>
            <span class="link">Recharge</span> -->
        </div>
    </div>
</div>
@if (data.userGateConfig && data.userGateProgress) {
    <div class="col gap-12 w100 streamlistwrapper">
        @if (packageName !== "") {
            <h3>{{ packageName }}</h3>
        }
        @if (!selectedGate) {
            @for (
                element of data.userGateProgress;
                track element;
                let i = $index
            ) {
                <div
                    class="w100 space-between row gap-24 stream align-center"
                    [ngClass]="
                        element.confirmedByCoach === true ? '' : 'notallowed'
                    "
                    (click)="
                        element.confirmedByCoach === true
                            ? chooseGate(element)
                            : null
                    "
                >
                    <h4 class="strong">
                        {{ element.name }}
                    </h4>
                    <div>{{ element.streamIdList.length }} Streams</div>
                </div>
            } @empty {
                <div class="w100 space-between row gap-24 align-center">
                    <h4>No Packages Found</h4>
                </div>
            }
        }
        @if (selectedGate) {
            <h3>{{ selectedGate.name }}</h3>
            @for (
                element of selectedGate.streamIdList;
                track element.streamId
            ) {
                <div
                    class="stream space-between row"
                    [ngClass]="
                        element.streamId === selectedStreamId ? 'selected' : ''
                    "
                    (click)="selectedStreamId = element.streamId"
                >
                    <div class="row gap-16 align-center">
                        <div class="dot col"></div>
                        <div class="col streamdescription">
                            <div class="strong">{{ element.streamName }}</div>
                        </div>
                    </div>
                    <div class="align-start">
                        <div class="row gap-8 align-center">
                            <div class="link tiny">0 Credits</div>
                            <rr-icon
                                name="info"
                                class="w16"
                                (mouseover)="
                                    openInfo(element.streamName, $event)
                                "
                                (mouseout)="closeInfo()"
                            ></rr-icon>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
} @else {
    <div class="searcharea">
        <div
            class="row space-between align-center"
            *ngIf="activeSearch === false"
        >
            <span class="strong"
                >{{ data.streamList.length }} Streams in the catalog</span
            >
            <rr-icon
                color="nutral"
                name="search"
                class="w24 pointer"
                (click)="activateSearch()"
            ></rr-icon>
        </div>
        <div
            class="gap-8 row space-between align-center"
            *ngIf="activeSearch === true"
        >
            <rr-input
                [(ngModel)]="searchValue"
                (keyup)="searchStream()"
                placeholder="Search streams"
                #searchinput
                id="searchinput"
            ></rr-input>
            <rr-icon
                color="nutral"
                name="close"
                class="w24 pointer"
                (click)="deactrivateSearch()"
            ></rr-icon>
        </div>
    </div>

    <!--New Stuff-->
    <div class="w100 row gap-8 maincatrow align-center">
        @for (cat of mainCategories; track cat.id; let i = $index) {
            <span
                [ngClass]="cat.active === true ? 'active' : ''"
                class="pointer"
                (click)="setVerticalToActive(cat.id)"
                >{{ cat.name }}</span
            >
            @if (i !== mainCategories.length - 1) {
                <span class="line"></span>
            }
        }
    </div>

    <!--END New Stuff-->

    <div class="col gap-12 w100 streamlistwrapper">
        @if (packageName !== "") {
            <h3>{{ packageName }}</h3>
        }
        @for (element of contentToShow; track element; let i = $index) {
            @if (element.showType === "PACKAGE") {
                <div
                    class="w100 space-between row gap-24 stream align-center"
                    (click)="choosePackage(element)"
                >
                    <h4 class="strong">
                        {{ element.name }}
                    </h4>
                    <div>{{ element.streams.length }} Streams</div>
                </div>
            }
            @if (element.showType === "STREAM") {
                <div
                    class="stream space-between row"
                    [ngClass]="{
                        noaccess:
                            data.userCredits > -1 &&
                            element.credits > data.userCredits,
                        selected: element.id === selectedStreamId,
                    }"
                    (click)="
                        data.userCredits > -1 &&
                        element.credits > data.userCredits
                            ? null
                            : (selectedStreamId = element.id)
                    "
                >
                    <div class="row gap-16 align-center">
                        <div class="dot col"></div>
                        <div class="col streamdescription">
                            <div class="strong">{{ element.name }}</div>
                            <!--<div class="tiny">
                            {{ element.description }}
                        </div>-->
                            <!--<div class="tiny">
                            {{ element.stepCount }} Steps | Approx.
                            {{
                                element.duration === 0
                                    ? element.stepCount * 5
                                    : element.duration
                            }}
                            min
                        </div>-->
                        </div>
                    </div>
                    <div class="align-start">
                        <div class="row gap-8 align-center">
                            <div class="link tiny">
                                {{ element.credits }} Credits
                            </div>
                            <rr-icon
                                name="info"
                                class="w16"
                                (mouseover)="
                                    openInfo(element.description, $event)
                                "
                                (mouseout)="closeInfo()"
                            ></rr-icon>
                        </div>
                    </div>
                </div>
            }
        } @empty {
            <div class="w100 space-between row gap-24 align-center">
                <h4>No Packages Found</h4>
            </div>
        }
    </div>
    <!--<div class="col gap-12 w100 streamlistwrapper">
    <div
        class="stream space-between row"
        *ngFor="let stream of streamSelectList"
        [ngClass]="stream.credits > data.userCredits ? 'noaccess' : ''"
        [ngClass]="stream.id === selectedStreamId ? 'selected' : ''"
        (click)="
            data.userCredits > -1 && stream.credits > data.userCredits
                ? null
                : (selectedStreamId = stream.id)
        "
    >
        <div class="row gap-16 align-center">
            <div class="dot"></div>
            <div class="col">
                <div class="strong">{{ stream.name }}</div>
                <div class="tiny">
                    {{ stream.stepCount }} Steps | Approx.
                    {{
                        stream.duration === 0
                            ? stream.stepCount * 5
                            : stream.duration
                    }}
                    min
                </div>
            </div>
        </div>
        <div class="align-start">
            <div class="row gap-8 align-center">
                <div class="link tiny">{{ stream.credits }} Credits</div>
                <rr-icon
                    name="info"
                    class="w16"
                    (mouseover)="openInfo(stream.description, $event)"
                    (mouseout)="closeInfo()"
                ></rr-icon>
            </div>
        </div>
    </div>
</div>-->
}
<rr-disclaimer class="w100" [type]="disaclaimerType"></rr-disclaimer>
<div class="row justify-end gap-8 w100 align-center">
    @if (showBackBtn === true) {
        <rr-btn
            type="Link"
            size="Medium"
            (click)="chooseBack()"
            iconStart="arrow-left"
            >Back</rr-btn
        >
    }
    <rr-btn type="Secondary" size="Medium" (click)="close()">Cancel</rr-btn>
    <rr-btn
        type="Primary"
        size="Medium"
        [disabled]="selectedStreamId == ''"
        (click)="selectedStreamId == '' ? null : startStream()"
        >Start</rr-btn
    >
</div>
@if (showInfo === true) {
    <div
        class="infodescription"
        [style]="'left:' + xcoord + 'px; top:' + ycoord + 'px;'"
    >
        {{ infoText }}
    </div>
}
